export default __webpack_public_path__ + "static/media/bitcoinService.3ff2d62d.svg";